import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-onei';

import TagService from '../../services/TagService';
import WordingService from '../../services/WordingService';

const Wrapper = styled.div`
  margin-top: 2.125rem;
  margin-bottom: 4.8rem;
`;

const Help = ({ isFirstConnection }) => (
  <Wrapper>
    <Link
      id="help-link"
      href={isFirstConnection ? window.reactAppEnv.href.helpFirstConnection : window.reactAppEnv.href.help}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => TagService.sendAction('assistance')}
      aria-label="Lien d'assistance Orange"
      title="Lien d'assistance Orange"
    >
      {WordingService.getWording('url', 'helpLabel')}
    </Link>
  </Wrapper>
);

export default Help;
